module.exports = __webpack_public_path__ + "static/media/d-and-d-beyond.375f649e.svg";